import { defineMessages } from 'react-intl-next';

export const messages: {
	autoscrollLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	autoscrollTooltipContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	autoscrollLabel: {
		id: 'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label',
		defaultMessage: 'Autoscroll',
		description:
			'A visible text label for the cards autoscroll section of the link cards config panel that informs the user that they can select either true or false.',
	},
	autoscrollTooltipContent: {
		id: 'company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content',
		defaultMessage:
			'Cards that don’t fit on the screen will start scrolling when you exit edit mode',
		description:
			'Tooltip content displayed on hover of information icon providing more details on autoscroll toggle.',
	},
});
